import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties, getId, } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateImageJson(imageJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // ImageJson => RichAssetImage => RichAsset => Node
    const parentNode = imageJson?.$container?.$container?.$container;
    const idField = getId(parentNode);
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: imageJson,
        allProperties: imageJson.properties,
        requiredProperties: [ast.TypeStaticProperty, ast.UrlProperty],
        parentNode,
        accept,
    });
    // The url should start with https.
    const urlProperty = imageJson.properties.find((prop) => {
        return ast.isUrlProperty(prop);
    });
    const url = urlProperty?.url?.value?.toLowerCase();
    if (url && url.startsWith('https://') === false) {
        accept('error', `URL should point to a secure (https) location.`, {
            node: imageJson,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
}
//# sourceMappingURL=image.js.map